export class AgentSettings {
	constructor(data = {}) {
		this.identity = {
			agentName: data.identity?.agentName || '',
			agentPersona: data.identity?.agentPersona || '',
			companyName: data.identity?.companyName || '',
			companyDescription: data.identity?.companyDescription || '',
			toneGuidelines: data.identity?.toneGuidelines || '',
			timezone: data.identity?.timezone || 'Asia/Riyadh',
			...data.identity,
		};

	this.escalationText = data.escalationText || '';
	this.domainKnowledge = data.domainKnowledge || '';
	this.proactiveMessagesEnabled = data.proactiveMessagesEnabled !== undefined ? data.proactiveMessagesEnabled : false;

	this.escalationPolicy = data.escalationPolicy || [];
	if (typeof this.escalationPolicy === 'string' && this.escalationPolicy) {
		this.escalationPolicy = [this.escalationPolicy];
	}

		this.bankAccountInfo = {
			accountName: data.bankAccountInfo?.accountName || '',
			iban: data.bankAccountInfo?.iban || '',
			bankName: data.bankAccountInfo?.bankName || '',
			accountNumber: data.bankAccountInfo?.accountNumber || '',
			...data.bankAccountInfo,
		};
	}

	toFirestore() {
		return {
			identity: this.identity,
			escalationText: this.escalationText,
			domainKnowledge: this.domainKnowledge,
			escalationPolicy: this.escalationPolicy,
			proactiveMessagesEnabled: this.proactiveMessagesEnabled,
			bankAccountInfo: this.bankAccountInfo,
			updatedAt: new Date().toISOString(),
		};
	}
}
